import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const StyledSharedIcons = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 25px 10px;
  width: 145px;
  cursor: pointer;
  svg {
    fill: #BBC3C3;
    height: 1.3em;
    width: 1.3em;
    :hover {
      fill: #AEDBD9;
    }
  }
`;

export const ReturnMobile = styled.div`
  width: 40px;
  height: 40px;

  svg {
    margin-bottom: 14px;
  }

  @media (min-width: 768px) { display: none; }
`